// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.059 1L20.9614 20.2076L12.0002 23.568L3.03898 20.2076L1.94141 1H22.059ZM7.78747 7H16.4952L18.215 7.01719L18.3304 5H5.66992L6.09145 12.3768L15.9055 12.3768L15.6959 16.0461L12.0002 17.432L8.30439 16.0461L8.25566 15.1933L8.2117 14.0734H6.1884L6.38199 17.4612L12.0002 19.568L17.6183 17.4612L18.0231 10.3768L7.98043 10.3768L7.78747 7Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-html5-filled')
export default class Html5FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'html5-filled',
    }
  }
}
